export const messages = {
    nb: {
        toastGetReportFailed: 'Henting av PowerBI rapport feilet',
        toastGetReportOk: 'Vennligst vent, PowerBi rapport lastes',       
    }
}